query SearchParameters(
    $term: String!
) {
    searchParameters(
        term: $term
    ) {
        id

        name(language: "en") {
            text
        }
    }
}
